import API from '..';
import { METHODS } from '../constants';
import utils from '../utils';

const cart = () => ({
  getCartDetails: async () => await utils.fetch(`${process.env.HOST}/api/transaction/cart/fetch-cart-details`),
  fetchOTP: (data) => utils.fetch(`${process.env.HOST}/api/transaction/cart/otp`, { data: data, method: METHODS.POST }),
  verifyOTP: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/cart/otp/verify`, { data: data, method: METHODS.POST }),
  updateInvestmentAmount: (orderId: String, investmentAmount: number, investmentId: string) =>
    utils.fetch(
      `${process.env.HOST}/api/transaction/cart/change-amount?orderId=${orderId}&investmentId=${investmentId}&amount=${investmentAmount}`,
      { method: METHODS.POST }
    ),
  removeCartItem: (orderId: String) =>
    utils
      .fetch(`${process.env.HOST}/api/transaction/cart/remove?orderId=${orderId}`, { method: METHODS.POST })
      .then(() => {
        API.cart.getCartDetails();
      }),
  getOnetimeAddToCart: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/cart/one-time/add-to-cart`, { data: data, method: METHODS.POST }),
  getSipAddToCart: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/cart/sip/add-to-cart`, { data: data, method: METHODS.POST }),
});

export default cart;